import axios from "axios"
import { API_BASE_URL } from "../shared/Config";

export const RedirectService = {
    getTenantRedirect: async function (urlParams: any) {
        const response = await axios.get(`${API_BASE_URL}/${urlParams.pool_id}/${urlParams.tenant}/redirect`)

        return response
    }
}